export enum RequestorType {
  Unknown = 0,
  Transport = 1,
  Quote = 2
}

export enum QuoteStatus {
  Unknown = 0,
  Created = 1,
  Posted = 2,
  ReviewBids = 3,
  BiddingClosed = 4,
  SubmittedForApproval = 5,
  Approved = 6,
  Declined = 7,
  Cancelled = 8,
  Awarded = 9
}

export enum ApprovalType {
  BasicApproval = 1,
  Sequential = 2,
  Parallel = 3,
  ApprovalByQuorum = 4
}

export enum TransportationMode {
  LessThanTruckload = 1,
  Truckload = 2,
  All = 3
}

export enum ResponseTimeType {
  OneHour = 1,
  SixHours,
  TwelveHours,
  Custom
}

export enum ReminderType {
  ThirtyMinutes = 1,
  OneHour,
  OneDay,
  Custom
}

export enum ApprovalStatusForApprover {
  Unknown = 0,
  Draft = 1,
  Sent = 2,
  Approved = 3,
  Rejected = 4,
  Cancelled = 5
}

export enum ServiceLevel {
  Standard = 1,
  Expedited = 2
}
